import { Box, Button, Paper } from '@material-ui/core';
import React, { MouseEventHandler } from 'react';
import { Link } from 'react-router-dom';

import { ConditionalWrapper } from '@/components/shared/components/ConditionalWrapper';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { Icon } from '@/components/shared/components/Icon';

import { useCustomTheme } from '../../../hooks/useCustomTheme';

export const ContrastedCard = ({
  children,
  paperProps,
  boxProps,
  endIcon,
  onClick,
  linkTo,
  disabled,
}: {
  children: React.ReactNode;
  boxProps?: React.ComponentProps<typeof Box>;
  paperProps?: React.ComponentProps<typeof Paper>;
  endIcon?: string;
  disabled?: boolean;
  onClick?: MouseEventHandler | undefined;
  linkTo?: string;
}) => {
  const { customBorderRadius } = useCustomTheme();
  const clickable = onClick !== undefined || linkTo;

  const currentPaperProps = {
    ...paperProps,
    style: {
      padding: 0,
      marginBottom: 16,
      ...paperProps?.style,
    } as React.CSSProperties,
  };
  const currentBoxProps = {
    ...boxProps,
    style: { padding: '8px 16px', boxSizing: 'border-box', ...boxProps?.style } as React.CSSProperties,
  };

  const wrapperButton = (wrapperChildren) => (
    <Button
      disabled={disabled}
      onClick={onClick}
      style={{
        justifyContent: 'space-between',
        padding: '0',
        borderRadius: customBorderRadius.paper,
        width: '100%',
      }}
    >
      {wrapperChildren}
    </Button>
  );

  return (
    <CustomPaper fill="grey.light" {...currentPaperProps} boxProps={{ height: '100%' }}>
      <ConditionalWrapper condition={!!clickable} wrapper={wrapperButton}>
        <Box
          width={'100%'}
          height={'100%'}
          display={'flex'}
          gridGap={4}
          justifyContent={'space-between'}
          flexDirection={'row'}
          alignItems={'center'}
          className={'lining-typography'}
          {...currentBoxProps}
        >
          {children}
          {(linkTo || endIcon) && (
            <Box flexShrink={0} display={'flex'} alignItems={'center'}>
              {linkTo ? (
                <Link to={linkTo} style={{ height: '20px' }}>
                  <Icon size={20}>{endIcon || 'chevron_right'}</Icon>
                </Link>
              ) : (
                <Icon size={20}>{endIcon || 'chevron_right'}</Icon>
              )}
            </Box>
          )}
        </Box>
      </ConditionalWrapper>
    </CustomPaper>
  );
};
